import React, { useRef, useState, useEffect } from 'react';
import AudioPlayer from './AudioPlayer';

function NavBar() {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  // close on outside click
  useEffect(() => {
    const onClick = (e) => {
      if (!open) return;
      if (menuRef.current && !menuRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  // close on escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-black/50 backdrop-blur z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
        <div className="text-neon font-pressstart text-sm">Barbary's Portfolio</div>

        {/* Desktop links */}
        <div className="hidden md:flex gap-4 items-center text-xs">
          <a href="#hero" className="text-neon hover:underline focus:outline-none focus:ring-2 focus:ring-neon">Home</a>
          <a href="#about" className="text-neon hover:underline focus:outline-none focus:ring-2 focus:ring-neon">About</a>
          <a href="#skills" className="text-neon hover:underline focus:outline-none focus:ring-2 focus:ring-neon">Skills</a>
          <a href="#projects" className="text-neon hover:underline focus:outline-none focus:ring-2 focus:ring-neon">Projects</a>
          <a href="#contact" className="text-neon hover:underline focus:outline-none focus:ring-2 focus:ring-neon">Contact</a>
          <a href="/resume.pdf" className="text-neon hover:underline focus:outline-none focus:ring-2 focus:ring-neon" download>Resume</a>
          <div className="ml-2">
            <AudioPlayer />
          </div>
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button ref={buttonRef} onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls="mobile-menu" className="text-neon px-3 py-2 border border-neon rounded">
            {open ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile overlay menu */}
      {open && (
        <div id="mobile-menu" ref={menuRef} className="md:hidden fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center gap-6 p-6">
          <a onClick={() => setOpen(false)} href="#hero" className="text-neon text-xl">Home</a>
          <a onClick={() => setOpen(false)} href="#about" className="text-neon text-xl">About</a>
          <a onClick={() => setOpen(false)} href="#skills" className="text-neon text-xl">Skills</a>
          <a onClick={() => setOpen(false)} href="#projects" className="text-neon text-xl">Projects</a>
          <a onClick={() => setOpen(false)} href="#contact" className="text-neon text-xl">Contact</a>
          <a href="/resume.pdf" className="text-neon text-xl" download>Resume</a>

          <div className="mt-2">
            <AudioPlayer />
          </div>

          <button onClick={() => setOpen(false)} className="mt-6 px-4 py-2 border border-neon">Close</button>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
